var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.174,
    cy: 29.834,
    r: 29.904,
    fill: "#8247e5",
    strokeLinecap: "round",
    strokeWidth: 0.61557
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m40.038 22.614c-0.72807-0.41604-1.6641-0.41604-2.4962 0l-5.8245 3.4323-3.9523 2.1842-5.7205 3.4323c-0.72806 0.41602-1.6642 0.41602-2.4962 0l-4.4724-2.7042c-0.72807-0.41603-1.2481-1.2481-1.2481-2.1842v-5.2004c0-0.83207 0.41604-1.6642 1.2481-2.1842l4.4724-2.6002c0.72807-0.41603 1.6642-0.41603 2.4962 0l4.4724 2.7042c0.72806 0.41602 1.2481 1.2481 1.2481 2.1842v3.4323l3.9523-2.2882v-3.5363c0-0.83207-0.41604-1.6641-1.2481-2.1842l-8.3207-4.8884c-0.72806-0.41604-1.6641-0.41604-2.4962 0l-8.5287 4.9924c-0.83206 0.41604-1.2481 1.2481-1.2481 2.0802v9.7768c0 0.83206 0.41605 1.6641 1.2481 2.1842l8.4247 4.8884c0.72807 0.41603 1.6642 0.41603 2.4962 0l5.7205-3.3283 3.9523-2.2882 5.7205-3.3283c0.72806-0.41602 1.6641-0.41602 2.4962 0l4.4724 2.6002c0.72807 0.41605 1.2481 1.2481 1.2481 2.1842v5.2004c0 0.83207-0.41604 1.6641-1.2481 2.1842l-4.3684 2.6002c-0.72807 0.41604-1.6641 0.41604-2.4962 0l-4.4724-2.6002c-0.72806-0.41602-1.2481-1.2481-1.2481-2.1842v-3.3283l-3.9523 2.2882v3.4323c0 0.83207 0.41604 1.6641 1.2481 2.1842l8.4247 4.8884c0.72806 0.41604 1.6642 0.41604 2.4962 0l8.4247-4.8884c0.72806-0.41602 1.2481-1.2481 1.2481-2.1842v-9.8808c0-0.83206-0.41603-1.6641-1.2481-2.1842z",
    fill: "#fff",
    strokeWidth: 1.0401
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/MATIC.7835ed77bbaeb6b20f3cc821ecc95c60.svg";
export { ForwardRef as ReactComponent };